__turbopack_context__.v({
  "className": "OEus3G_className",
  "variable": "OEus3G_variable",
});
